import FormAntragDto from "../../../../consumer/form/dto/FormAntragDto";
import moment from "moment";
import StvAnrede from "../../../../consumer/form/dto/StvAnrede";
import StvTitel from "../../../../consumer/form/dto/StvTitel";
import { exportVnName, importVnName } from "./form-vn/input/VnName";
import { exportVnVorname, importVnVorname } from "./form-vn/input/VnVorname";
import { exportVnAnrede, importVnAnrede } from "./form-vn/input/VnAnrede";
import { exportVnGeburtsdatum, importVnGeburtsdatum } from "./form-vn/input/VnGeburtsdatum";
import { exportVnAnschriftHsnr, importVnAnschriftHsnr } from "./form-vn/input/VnAnschriftHsnr";
import { exportVnAnschriftStrasse, importVnAnschriftStrasse } from "./form-vn/input/VnAnschriftStrasse";
import { exportVnAnschriftPlz, importVnAnschriftPlz } from "./form-vn/input/VnAnschriftPlz";
import { exportVnAnschriftOrt, importVnAnschriftOrt } from "./form-vn/input/VnAnschriftOrt";
import { exportVnKommEmailPrivat, importVnKommEmailPrivat } from "./form-vn/input/VnKommEmailPrivat";
import { exportVnKommHandyPrivat, importVnKommHandyPrivat } from "./form-vn/input/VnKommHandyPrivat";
import { exportVsBeginn } from "./form-antrag/InputVsBeginn";
import { exportBankIban, importBankIban } from "./form-bank/input/Bank";
import { exportOptInMail } from "./form-optin/input/OptInMail";
import { exportOptInTelefon } from "./form-optin/input/OptInTelefon";
import { exportVorschaden } from "./form-vorschaden/input/Vorschaden";
import { exportVnTitel, importVnTitel } from "./form-vn/input/VnTitel";
import { exportOptInSms } from "./form-optin/input/OptInSms";
import StvJaNeinUnbekannt from "../../../../consumer/form/dto/StvJaNeinUnbekannt";
import { exportVorschadenFreitext } from "./form-vorschaden/input/VorschFreitext";

export default class FormBo {
    vnAnrede?: StvAnrede = StvAnrede.HERR;
    vnTitel?: StvTitel = StvTitel.KEIN_TITEL;
    vnName?: string = '';
    vnVorname?: string = '';
    vnGeburtsdatum?: string;

    // *** Anschrift
    vnAnschriftStrasse?: string = '';
    vnAnschriftHsnr?: string = '';
    vnAnschriftPlz?: string = '';
    vnAnschriftOrt?: string = '';

    // *** Kommunikation
    vnKommEmailPrivat?: string = '';
    vnKommEmailPrivatValid?: boolean;
    vnKommHandyPrivat?: string = '';

    // *** Produkt
    produktVsBeginn?: string = moment().format('DD.MM.YYYY');

    // *** Bankverbindung    
    bankIban?: string = '';

    // *** OptIn
    optInMail?: boolean = false;
    optInSms?: boolean = false;
    optInTelefon?: boolean = false;

    // *** Vorschaden
    vorschaden?: StvJaNeinUnbekannt = StvJaNeinUnbekannt.UNBEKANNT;
    vorschadenFreitext?: string = '';

    // *** VVI
    vviBestaetigung?: boolean = false;
    vviBestaetigungEMail?: string = '';

    static exportFormulardaten(bo: FormBo) {
        const dto = new FormAntragDto();
        dto.vnTitel = exportVnTitel(bo);
        dto.vnAnrede = exportVnAnrede(bo);
        dto.vnName = exportVnName(bo);
        dto.vnVorname = exportVnVorname(bo);
        dto.vnGeburtsdatum = exportVnGeburtsdatum(bo);
        dto.vnAnschriftStrasse = exportVnAnschriftStrasse(bo);
        dto.vnAnschriftHsnr = exportVnAnschriftHsnr(bo);
        dto.vnAnschriftPlz = exportVnAnschriftPlz(bo);
        dto.vnAnschriftOrt = exportVnAnschriftOrt(bo);
        dto.vnKommEmailPrivat = exportVnKommEmailPrivat(bo);
        dto.vnKommHandyPrivat = exportVnKommHandyPrivat(bo);
        dto.produktVsBeginn = exportVsBeginn(bo);
        dto.bankIban = exportBankIban(bo);
        dto.optInMail = exportOptInMail(bo);
        dto.optInSms = exportOptInSms(bo);
        dto.optInTelefon = exportOptInTelefon(bo);
        dto.vorschaden = exportVorschaden(bo);
        dto.vorschadenFreitext = exportVorschadenFreitext(bo);
        return dto;
    }

    static importFormulardaten(dto?: FormAntragDto) {
        const bo = new FormBo()

        if (dto === undefined) {
            return bo;
        }

        // vnAnrede
        FormBo.setImportValue(
            importVnAnrede,
            v => bo.vnAnrede = v,
            dto.vnAnrede
        );

        // VnName
        FormBo.setImportValue(
            importVnName,
            v => bo.vnName = v,
            dto.vnName
        );

        // VnVorname 
        FormBo.setImportValue(
            importVnVorname,
            v => bo.vnVorname = v,
            dto.vnVorname
        );

        // vnGeburtsdatum
        FormBo.setImportValue(
            importVnGeburtsdatum,
            v => bo.vnGeburtsdatum = v,
            dto.vnGeburtsdatum
        );

        // vnTitel
        FormBo.setImportValue(
            importVnTitel,
            v => bo.vnTitel = v,
            dto.vnTitel
        );

        // VnAnschriftStrasse
        FormBo.setImportValue(
            importVnAnschriftStrasse,
            v => bo.vnAnschriftStrasse = v,
            dto.vnAnschriftStrasse
        );

        // vnAnschriftHsnr
        FormBo.setImportValue(
            importVnAnschriftHsnr,
            v => bo.vnAnschriftHsnr = v,
            dto.vnAnschriftHsnr
        );

        // vnAnschriftPlz
        FormBo.setImportValue(
            importVnAnschriftPlz,
            v => bo.vnAnschriftPlz = v,
            dto.vnAnschriftPlz
        );

        // vnAnschriftOrt
        FormBo.setImportValue(
            importVnAnschriftOrt,
            v => bo.vnAnschriftOrt = v,
            dto.vnAnschriftOrt
        )

        // vnKommEmailPrivat
        FormBo.setImportValue(
            importVnKommEmailPrivat,
            v => bo.vnKommEmailPrivat = v,
            dto.vnKommEmailPrivat
        )

        // vnKommHandyPrivat
        FormBo.setImportValue(
            importVnKommHandyPrivat,
            v => bo.vnKommHandyPrivat = v,
            dto.vnKommHandyPrivat
        );

        // bankIban
        FormBo.setImportValue(
            importBankIban,
            v => bo.bankIban = v,
            dto.bankIban
        )

        return bo;
    }

    static setImportValue<T>(
        getImportValue: (v: T) => T | undefined,
        setValue: (v: T) => {},
        dtoValue?: T) {

        if (dtoValue !== undefined && dtoValue !== null) {
            const importValue = getImportValue(dtoValue);

            if (importValue !== undefined) {

                setValue(importValue);
            }
        }
    }
}